export const BASE = {
  name: 'engage-insights',
  path: '/research',
};

export const LIST = {
  name: 'engage-insights.list',
  path: `${BASE.path}/list`,
};
